<div [formGroup]="form">
  <label
    for="{{ item.formControlName }}"
    class="custom-form-field__label"
  >
    {{ item.label }}
  </label>
  <p-multiSelect
    id="{{ item.formControlName }}"
    [options]="options"
    [selectionLimit]="selectionLimit"
    [formControlName]="item.formControlName"
    defaultLabel="{{ item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : '' }}"
    optionValue="value"
    [optionLabel]="optionLabel"
    [attr.aria-describedby]="item.formControlName + '-error'"
  ></p-multiSelect>
</div>
